<template>
  <div
    :class="[
      'loader',
      {
        'loader--init': !appState.init,
        'loader--hidden': appState.init && !appState.loading && !fauxLoading,
        'loader--messages': messages,
        'loader--dots-active': dotsActive,
      }
    ]"
  >
    <div class="loader__items">
      <div class="message__block" :style="[wrapperStyle]"/>
      <module-messages
        v-if="messages"

        :messages="messages"

        @messages-complete="onMessagesComplete"
        @messages-height="onMessagesSetup"
      />
      <module-dots />
    </div>
  </div>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Modules
import ModuleDots from 'components/Dots';
import ModuleMessages from 'components/LoaderMessages';

// Export
export default {
  name: 'ui-loader',

  // Components
  components: {
    ModuleDots,
    ModuleMessages,
  },

  // Data
  data() {
    return {
      messages: null,
      offsetHeight: 0,
      dotsActive: false,
      fauxLoading: false,
    };
  },

  // Computed
  computed: {
    ...mapGetters('app', [
      'appState',
      'appPage',
      'messagesOverride',
    ]),

    isActive() {
      return this.appState.loading && this.appState.init;
    },

    wrapperStyle() {
      return {
        'height': `${this.offsetHeight}px`,
      };
    },
  },

  // Watch
  watch: {
    'appPage.fullPath'() {
      this.triggerMessages();
    },
    'messagesOverride'(messages = null) {
      if (messages) {
        this.triggerMessages(messages);
      }
    },
  },

  // Methods
  methods: {
    ...mapActions('app', [
      'closeLoader',
      'setMessages',
    ]),
    triggerMessages(messagesOverride) {
      const messages = messagesOverride || this.appPage.meta.messages || [];

      if (!messages.length) {
        this.fauxLoading = true;
        this.dotsActive = true;

        setTimeout(() => {
          this.closeLoader();
          this.fauxLoading = false;
          this.dotsActive = false;

          if (messagesOverride) {
            setTimeout(() => {
              this.setMessages(null);
            }, 300); // TODO: Var
          }
        }, 300); // TODO: Var

        return false;
      }

      this.$set(this, 'messages', messages);
    },

    onMessagesComplete() {
      this.dotsActive = false;
      this.fauxLoading = false;
      this.closeLoader();

      setTimeout(() => {
        this.$set(this, 'messages', null);
        if ((this.messagesOverride || []).length) this.setMessages(null);
      }, 300); // TODO: import config time
    },

    onMessagesSetup(value) {
      if (typeof value === 'number') {
        this.offsetHeight = value;
      }

      this.fauxLoading = true;
      this.dotsActive = true;
    },
  },

  // Lifecycle
  created() {
    // WHY: With HMR enabled the loader is being opened when it remakes the page, but because the
    //      route doesn't change (and thus the `watch` above isn't triggered) the loader is never
    //      closed. This code detects a change, and at the point that it has been changed it triggers
    //      the messages again.
    if (module.hot) {
      module.hot.addStatusHandler(status => {
        if (status !== 'apply') return;
        setTimeout(() => this.triggerMessages(), 250);
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// Loader.vue?0c3c27e7